import { isEmpty } from "./validationUtil";
import { isValidEmail } from "./emailValidationUtil";

/**
 *         const clientObject = {
            description: activityDescription,
            clientTicketRef: activityClientTicketRef,
            ownerId: ownerId.ownerId,
            startDate: getDateInFormat(activityStartDate),
            endDate: getDateInFormat(activityEndDate),
            status: activityStatus,
            hoursSpent: parseInt(activityHoursSpent, 10),
        };
 * @param {*} clientObject 
 */
export const validateClientObject = (clientObject) => {

    // Must have certain fields
    var isValid = clientObject.hasOwnProperty("name") && !isEmpty(clientObject.name);
    isValid = isValid && clientObject.hasOwnProperty("code") && !isEmpty(clientObject.code);
    // contactPersonEmail is optional

    return isValid;
    // Field value validation
}

export const validateWorkingHourObject = (object) => {

    // Must have certain fields 
    console.log(object);
    var isValid = object.hasOwnProperty("location") && !isEmpty(object.location);
    isValid = isValid && object.hasOwnProperty("clientId") && !isEmpty(object.clientId);
    isValid = isValid && object.hasOwnProperty("hour") && !isEmpty(object.hour);
    
    return isValid;
    // Field value validation
}

export const validateClientMappingObject = (clientObject) => {

    // Must have certain fields 
    var isValid = clientObject.hasOwnProperty("userId") && !isEmpty(clientObject.userId);
    isValid = isValid && clientObject.hasOwnProperty("clientId") && !isEmpty(clientObject.clientId);
    
    return isValid;
    // Field value validation
}